import { User } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { FaPlus } from "react-icons/fa";
import { MdLanguage } from "react-icons/md";

import { extractUrl } from "../../../../../../../PageUpdateProfile/fields/FieldSocialLinkItem/utils";

import styles from "./index.module.scss";

import { useLoginStatus } from "@/modules/common-hooks/useLoginStatus";
import { CHANNEL_KEY_TO_CHANNEL_INFO } from "@/modules/social-links/config";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  user: User | null | undefined;
};

export default function SectionSocialLinks({ className, style, user }: Props) {
  const loginStatus = useLoginStatus();
  const router = useRouter();
  const socialLinks = user?.socialLinks || [];

  return (
    <Flex.Row gap="12px" className={className} style={style}>
      {socialLinks.length ? (
        socialLinks.map((href, index) => {
          const { host } = extractUrl(href);
          const channelInfo = Object.values(CHANNEL_KEY_TO_CHANNEL_INFO).find(
            (channelInfo) =>
              channelInfo.acceptedDomains.some(
                (d) => d === host || host.endsWith("." + d)
              )
          );
          return (
            <Link
              key={index}
              href={href}
              className={styles.iconContainer}
              rel="noreferer"
              target="_blank"
            >
              {channelInfo?.icon || <MdLanguage />}
            </Link>
          );
        })
      ) : loginStatus?.loggedIn && loginStatus.userId === user?.userId ? (
        <button
          className={styles.iconContainer}
          onClick={() => {
            router.push("/me/edit");
          }}
        >
          <FaPlus />
        </button>
      ) : null}
    </Flex.Row>
  );
}
